"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedAccountIdSelector = exports.selectMarginInstrumentConfig = exports.selectMarginConfig = exports.selectAccountMarginInfo = exports.notMarginAccountsSelector = exports.marginTransferAmountsSelector = exports.marginTransferAmountSelector = exports.marginSystemEnabledSelector = exports.marginProductsSelector = exports.marginNotificationsSelector = exports.marginNavNotificationSelector = exports.marginKVPInfoSelector = exports.marginBorrowerEnabledSelector = exports.marginAccountSelector = exports.marginAccountEquitySelector = exports.mainAccountSelector = exports.isMarginEnabledSelector = exports.isMarginActiveSelector = exports.defaultAccountSelector = exports.assetAccountSelector = exports.accountsSelector = void 0;
var _reselect = require("reselect");
// Checks whether the Operator + User has margin capability.
var isMarginEnabledSelector = exports.isMarginEnabledSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.user.accounts;
}, function (userInfo, accounts) {
  return !!userInfo.MarginBorrowerEnabled && accounts.some(function (account) {
    return account.AccountType === 'Margin';
  });
});
var marginAccountSelector = exports.marginAccountSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.find(function (account) {
    return account.AccountType === 'Margin';
  });
});
var mainAccountSelector = exports.mainAccountSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  var assetAccounts = accounts.filter(function (account) {
    return account.AccountType === 'Asset';
  });
  return assetAccounts.length ? assetAccounts.sort(function (a, b) {
    return a.AccountId - b.AccountId;
  })[0] : null;
});
var assetAccountSelector = exports.assetAccountSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.find(function (account) {
    return account.AccountType === 'Asset';
  });
});
var notMarginAccountsSelector = exports.notMarginAccountsSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.filter(function (account) {
    return account.AccountType !== 'Margin';
  });
});
var accountsSelector = exports.accountsSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts;
});
var selectedAccountIdSelector = exports.selectedAccountIdSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.selectedAccountId;
}, function (selectedAccountId) {
  return selectedAccountId;
});
var isMarginActiveSelector = exports.isMarginActiveSelector = (0, _reselect.createSelector)(marginAccountSelector, selectedAccountIdSelector, function (marginAccount, selectedAccountId) {
  return marginAccount && selectedAccountId && marginAccount.AccountId === selectedAccountId;
});
var defaultAccountSelector = exports.defaultAccountSelector = (0, _reselect.createSelector)(notMarginAccountsSelector, function (state) {
  return state.user.userInfo.AccountId;
}, function (accounts, defaultAccountId) {
  return accounts.find(function (acct) {
    return acct.AccountId === defaultAccountId;
  });
});
var selectAccountMarginInfo = exports.selectAccountMarginInfo = (0, _reselect.createSelector)(function (state) {
  return state.margin.accountInfo;
}, function (accountInfo) {
  return accountInfo;
});
var selectMarginConfig = exports.selectMarginConfig = (0, _reselect.createSelector)(function (state) {
  return state.margin.instrument;
}, function (marginConfig) {
  return marginConfig;
});
var selectMarginInstrumentConfig = exports.selectMarginInstrumentConfig = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.instrument.selectedInstrumentId;
}, function (state) {
  return state.margin.instrument.instruments;
}, function (selectedInstrument, config) {
  return config.find(function (c) {
    return c.InstrumentId === selectedInstrument;
  });
});
var marginSystemEnabledSelector = exports.marginSystemEnabledSelector = function marginSystemEnabledSelector(state) {
  return state.margin.systemMarginEnabled;
};
var marginBorrowerEnabledSelector = exports.marginBorrowerEnabledSelector = function marginBorrowerEnabledSelector(state) {
  return state.user.userInfo.MarginBorrowerEnabled;
};
var marginKVPInfoSelector = exports.marginKVPInfoSelector = function marginKVPInfoSelector(state) {
  return state.margin.marginKVPInfo;
};
var marginProductsSelector = exports.marginProductsSelector = function marginProductsSelector(state) {
  return state.margin.products;
};
var marginAccountEquitySelector = exports.marginAccountEquitySelector = function marginAccountEquitySelector(state) {
  return state.margin.marginEquity;
};
var marginTransferAmountsSelector = exports.marginTransferAmountsSelector = function marginTransferAmountsSelector(state) {
  return state.margin.transferAmounts;
};
var marginTransferAmountSelector = exports.marginTransferAmountSelector = (0, _reselect.createSelector)(marginTransferAmountsSelector, function (_, productId) {
  return productId;
}, function (transferAmounts, productId) {
  var _transferAmounts$prod, _transferAmounts$prod2;
  return (_transferAmounts$prod = (_transferAmounts$prod2 = transferAmounts[productId]) === null || _transferAmounts$prod2 === void 0 ? void 0 : _transferAmounts$prod2.MaxAmount) !== null && _transferAmounts$prod !== void 0 ? _transferAmounts$prod : null;
});
var marginNotificationsSelector = exports.marginNotificationsSelector = function marginNotificationsSelector(state) {
  return state.margin.notifications;
};
var marginNavNotificationSelector = exports.marginNavNotificationSelector = function marginNavNotificationSelector(state) {
  return state.margin.navNotification;
};